import React, { useState, useRef } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

function UploadModal({ show, onClose, paymentId, id }) {
    const navigate = useNavigate();
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const fileInputRef = useRef(null);

    const handleFileChange = (event) => {
        const files = Array.from(event.target.files);
        setSelectedFiles(files);
    };

    const handleButtonClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (selectedFiles.length === 0) {
            alert("Selecione pelo menos um arquivo antes de enviar.");
            return;
        }

        // Previne novos cliques
        setIsSubmitting(true);

        try {
            const formData = new FormData();
            // Adiciona cada arquivo selecionado ao FormData
            selectedFiles.forEach((file) => {
                formData.append("upload", file);
            });

            const response = await axios.post(
                `/api/novo/comprovante/${paymentId}`,
                formData,
                {
                    withCredentials: true,
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }
            );

            console.log(response);

            if (response.data.status === 200) {
                window.location.reload();
                console.log("Passa no reload sem fazer nada");
            } else {
                alert("Erro ao subir os anexos!");
            }
        } catch (error) {
            console.error("Erro ao enviar o formulário:", error);
            alert("Erro ao enviar o formulário.");
        } finally {
            // Reabilita o botão em qualquer cenário (sucesso ou erro)
            setIsSubmitting(false);
        }
    };

    if (!show) return null;

    return (
        <div
            className="modal fade show"
            style={{ display: "block" }}
            tabIndex="-1"
            role="dialog"
            aria-labelledby="uploadModalLabel"
            aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                    <form onSubmit={handleSubmit}>
                        <div className="modal-header">
                            <h5 className="modal-title" id="uploadModalLabel">
                                Comprovante
                            </h5>
                            <button
                                type="button"
                                className="close"
                                onClick={onClose}
                                aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="mb-3">
                                <label className="form-label">
                                    Suba aqui seus comprovantes:
                                </label>
                                <div className="file-drop-area border p-3">
                                    {/* Input file oculto */}
                                    <input
                                        ref={fileInputRef}
                                        type="file"
                                        multiple
                                        onChange={handleFileChange}
                                        style={{ display: "none" }}
                                    />
                                    {/* Botão customizado */}
                                    <button
                                        type="button"
                                        className="btn btn-outline-primary"
                                        onClick={handleButtonClick}>
                                        Escolher arquivos
                                    </button>
                                </div>
                            </div>
                            {selectedFiles.length > 0 && (
                                <div className="mt-2">
                                    <strong>Arquivos selecionados:</strong>
                                    <ul>
                                        {selectedFiles.map((file, index) => (
                                            <li key={index}>{file.name}</li>
                                        ))}
                                    </ul>
                                </div>
                            )}
                        </div>
                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-secondary"
                                onClick={onClose}
                                disabled={isSubmitting}>
                                Fechar
                            </button>
                            <button
                                type="submit"
                                className="btn btn-primary"
                                disabled={selectedFiles.length === 0 || isSubmitting}>
                                Salvar
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default UploadModal;
